import { FetchDataProps } from "types/datacontext";
import { fetchFilters, fetchSessions } from "api/webservice/sessions";
import {  QueryFunctionContext } from "@tanstack/react-query";
import { addDefaultFilters, constructProps } from "utils/repo";


// QueryKey Factory
// LazyDataTable accepts either a QueryKey from react-query
// or a function that accepts FetchDataProps and returns a
// QueryKey. Here we provide a factory function for the function
// that LazyDataTable expects. Using a factory function lets us
// include default values and data-specific props that are not accounted
// for by FetchDataProps
// Accepts an owned property, and a defaults property.
export const queryKeys = {
  data: (owned = false, defaults?: Partial<FetchDataProps>) =>
    (props?: FetchDataProps) =>
      ['sessions', owned, constructProps(props, defaults)],
  filters: (owned = false) => ['sessions', 'filters', owned],
}

// QueryFn Factory
// notice that these functions take the queryKey as an argument.
// This means that FetchDataProps from LazyDataTable will come in
// automagically.
export const queryFns = {
  data: ({ queryKey }: QueryFunctionContext) => {
    const [, owned, props] = queryKey;
    const { pageIndex, pageSize, filters, order, search, defaultFilters } = props as FetchDataProps || {};
    return fetchSessions(pageIndex, pageSize, owned as boolean, order, addDefaultFilters(props as FetchDataProps), search);
  },
  filters: ({ queryKey }: QueryFunctionContext) => {
    const [, , owned] = queryKey;
    return fetchFilters(owned as boolean);
  }
}

